<nav class="navbar">
  <div class="container-fluid d-flex justify-content-between align-items-center px-3">
    <!-- Logo shown when sidebar is collapsed -->
    <div class="topbar-logo" *ngIf="isSidebarCollapsed">
      <img
        [src]="isPayrollEmployer() ? 'assets/images/logo_images/PAYROLL%202_new.png' : 'assets/images/logo_images/PAYDAY 1.png'"
        alt="CIXOR logo"
        class="topbar-logo-img"
        loading="eager"
        decoding="async"
      />
    </div>
    <div *ngIf="!isSidebarCollapsed"></div>

    <!-- Notification Bell -->
    <div class="notification-wrapper" (click)="$event.stopPropagation()">
      <button class="bell-btn" (click)="toggleNotifications($event)" [class.active]="isNotificationOpen" aria-label="Notifications">
        <i class="bi bi-bell fs-5"></i>
        <span class="badge-dot" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
      </button>

      <!-- Dropdown Panel -->
      <div class="notification-dropdown" *ngIf="isNotificationOpen">
        <div class="notification-header">
          <span class="notif-title">Notifications</span>
          <div class="header-actions" *ngIf="notifications.length > 0">
            <button class="header-action-btn" (click)="markAllAsRead()" *ngIf="unreadCount > 0" title="Mark all as read">
              <i class="bi bi-check2-all"></i> Read All
            </button>
            <button class="header-action-btn danger" (click)="clearAll()" title="Clear all notifications">
              <i class="bi bi-trash3"></i> Clear All
            </button>
          </div>
        </div>

        <div class="notification-list">
          <!-- Loading state -->
          <div class="no-notifications" *ngIf="isLoadingNotifications">
            <i class="bi bi-arrow-repeat spin"></i>
            <p>Loading...</p>
          </div>

          <ng-container *ngIf="!isLoadingNotifications">
            <div
              class="notification-item"
              *ngFor="let notif of notifications"
              [class.unread]="!notif.isRead"
              [class.support-notif]="isSupportNotification(notif)"
              (click)="onNotificationClick(notif)"
            >
              <div class="notif-icon-wrap">
                <i class="bi" [ngClass]="isSupportNotification(notif) ? 'bi-chat-dots' : 'bi-bell'"></i>
              </div>
              <div class="notif-content">
                <div class="notif-item-title">{{ notif.title }}</div>
                <div class="notif-message">{{ notif.message }}</div>
                <div class="notif-time">{{ notif.createdAt | date:'short' }}</div>
              </div>
              <div class="notif-actions">
                <span class="unread-dot" *ngIf="!notif.isRead"></span>
                <button class="clear-item-btn" (click)="clearNotification($event, notif)" title="Dismiss">
                  <i class="bi bi-x"></i>
                </button>
              </div>
            </div>

            <div class="no-notifications" *ngIf="notifications.length === 0">
              <i class="bi bi-bell-slash"></i>
              <p>No notifications</p>
            </div>
          </ng-container>
        </div>

        <!-- Pagination Footer -->
        <div class="notif-pagination" *ngIf="!isLoadingNotifications && totalPages > 1">
          <i class="bi bi-chevron-left page-icon" [class.disabled]="currentPage === 1" (click)="prevPage()" title="Previous page"></i>
          <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
          <i class="bi bi-chevron-right page-icon" [class.disabled]="currentPage === totalPages" (click)="nextPage()" title="Next page"></i>
        </div>
      </div>
    </div>
  </div>
</nav>
